import { on } from '@ngrx/store';
import {
  ResourceData,
  ResourceIRI,
} from '../../../elements/resource/resource.types';
import {
  addNewState,
  deselectAllShapes,
  deselectShape,
  setNewShapeAction,
  removeState,
  resetPatchedShapes,
  selectAllShapes,
  selectShape,
  setCurrentState,
  setSaveLoading,
  setShapeLabel,
  toggleSelectAction,
  updateDescriptorOfShapeBaseAction,
  setOriginalDescriptor,
  setBBoxOfShape,
  setCurrentDescriptor,
  updateCurrentDescriptorBaseAction,
  setShapeTranslateBase,
  setShapeOriginalTransform,
  setCurrentShapeTranslate,
  setShowComponentSearch,
  setOriginalSVGAttributes,
  setCurrentSVGAttributesOfShape,
  setSVGAttributesOfShape,
  setBaseShapeTransform,
  setDescriptorSubAttribute,
  setCurrentDescriptorSubAttribute,
  setCurrentScene,
  setFileChanged,
  addSubScene,
  setSubSceneName,
  saveSubScenePosition,
  setCanvasPosition,
  selectSubSceneBase,
  setCurrentScenes,
  setNoAnimationMode,
  setFontLoaded,
  setSelectedShapes,
  setLoadedScenes,
  addLoadedScene,
  addState,
  selectState,
  setAttributeByState,
  saveScenePosition,
  resetBaseState,
  bulkUpdateFinish,
  setScenes,
  setCanvasShapes,
  setShapes,
  setShape,
  setcompleteShapeDescriptor,
  addToFileVisitStack,
  popVisitStack,
  loadFileAction,
  setSubsceneLoaded,
  setBulkUpdateItem,
  clearBulkUpdates,
  setShapeDescriptors,
  setResourcePatch,
  setResourceDelete,
  setResourcePost,
  setSelectedStoryBoardItem,
  setStoryBoardItem,
  setFontDescriptor,
  toggleEditorState,
  setFileLoading,
  setHiddenShape,
  setChangeTookPlace,
  setCommentDraft,
  clearCommentDraft,
  setPreviewShapeLoading,
  setExportIsInProgress,
  setOverlay,
  generateImageSuccess,
  generateImage,
  setImagePromptText,
  clearImagePrompt,
  setAnimationConfigBase,
  setFiles,
  setContainerMenuItem,
  removeContainerMenuItem,
  setHoveredShape,
  clearContainerMenu,
  setRelationshipBase,
  _setRelationshipBase,
  setFile,
  setContainerMenuItemState,
  setContainerItemAction,
  setProjectInput,
  setProjectPreviewIsLoading,
  setNewProjectName,
} from '../editor.actions';
import { createImmerReducer } from 'ngrx-immer/store';
import { current } from 'immer';
import {
  BBox,
  GeneralShapeDescriptor,
  SVGAttributes,
  Scene,
  ShapeIRI,
  ShapeTransform,
  AnimationKeys,
  AnimationValue,
  AnimationInnerKey,
  AnimationItem,
  ContainerMenuItem,
} from '../../../elements/resource/types/shape.type';
import {
  set as _set,
  get as _get,
  pick as _pick,
  set,
  omit,
  cloneDeep,
} from 'lodash';
import {
  deleteShapeAction,
  deleteShapeFromFileAction,
} from '../editor.crud.actions';
import { FontDescriptor } from '../../control-panel/canvas-control-panel/text/font.service';
import {
  addAnimationsOfShapesToStoreBase,
  removeAnimationItemBaseAction,
  setCurrentAnimationId,
} from '../../animation/store/animation.actions';
import { AnimationId } from '../../animation/frame/animation-frame-object';
import { IdToIRI } from '../../../util/iri';
import {
  loadProjectWithFilesById,
  setCurrentFileID,
  setCurrentFileIRI,
} from '../../../projects/project.actions';
import { string } from 'mathjs';
import { ShapeModule } from '../../shape/shape.module';
import { addPrompt } from '../editor.actions';

import {
  setColors,
  addColor,
  removeColor,
  updateColor,
  reorderColors,
  clearColors,
} from '../editor.actions';

export interface SceneState {
  current?: string[];
  scenes: Scene[];
}
export interface CanvasPosition {
  x: number;
  y: number;
  scale: {
    x: number;
    y: number;
  };
}
export type RelationshipPatches = Record<
  ShapeIRI,
  Record<string, string | Record<string, boolean>>
>;
export type UpdatesByState = Record<string, Record<string, any>>;
export type BulkUpdates = Record<
  ShapeIRI,
  { base?: boolean; value: BulkUpdateItems }
>;
export type BulkUpdatesNew = Record<ShapeIRI, BulkUpdateItems>;
export type BulkUpdateItems = Partial<
  Record<
    AnimationKeys,
    Record<
      AnimationInnerKey,
      {
        value: AnimationValue;
        base?: boolean;
      }
    >
  >
>;

export type BulkUpdateItemsNew = Partial<
  Record<
    AnimationKeys,
    {
      innerKey?: AnimationInnerKey;
      value: AnimationValue;
      base?: boolean;
    }
  >
>;
export interface ResourcePatch {
  literals?: {
    label?: boolean;
    descriptor?: boolean;
  };
  relationships?: {
    file?: boolean;
    instanceOf?: boolean;
    componentOf?: boolean;
    maskedBy?: boolean;
  };
}
export interface CrudEvents {
  patches: Record<string, ResourcePatch>;
  posts: Record<string, 'nw:Shape' | 'nw:File'>;
  deletes: Record<string, 'nw:Shape' | 'nw:File'>;
}

export interface EditorState {
  // resources: Record<string, ResourceData>;
  fontDescriptors?: Record<string, FontDescriptor>;
  shapes?: Record<string, ResourceData>;
  descriptors?: Record<string, GeneralShapeDescriptor>;
  hiddenShapes?: Record<string, boolean>;
  currentDescriptors?: Record<string, GeneralShapeDescriptor>;
  originalDescriptors?: Record<ShapeIRI, GeneralShapeDescriptor>;
  baseSvgAttributes?: Record<ShapeIRI, SVGAttributes>;
  originalSVGAttributes?: Record<ShapeIRI, SVGAttributes>;
  currentSVGAttributes?: Record<ShapeIRI, SVGAttributes>;
  baseShapeTransforms?: Record<ShapeIRI, ShapeTransform>;
  originalShapeTransforms?: Record<ShapeIRI, ShapeTransform>;
  currentShapeTransforms?: Record<ShapeIRI, ShapeTransform>;
  selectedShapes?: Record<string, boolean>;
  showComponentSearch?: boolean;
  loading?: boolean;
  isPatchLoading?: boolean;
  isProjectLoading?: boolean;
  isSaveLoading?: boolean;
  currentScene?: string[];
  currentMainScene?: string;
  scenes?: Scene[];
  bBoxes?: Record<string, BBox>;
  colorPalette?: Record<string, string>;
  fileChanged?: boolean;
  canvasPosition?: CanvasPosition;
  noAnimationMode?: boolean;
  fontLoaded?: boolean;
  loadedScenes?: Record<string, boolean>;
  states?: string[];
  selectedState?: string;
  updatesByState?: Record<ShapeIRI, UpdatesByState>;
  visitStack?: string[];
  scenesAreLoaded?: boolean;
  bulkUpdates?: BulkUpdates;
  bulkUpdatesNew?: BulkUpdatesNew;
  crudEvents?: CrudEvents;
  selectedStoryBoardItem?: number;
  editorState?: {
    projectLoading?: 'loading' | 'loaded' | 'error';
    panelOpened: 'fill' | 'stroke';
  };
  isFileLoading?: boolean;
  changeTookPlace?: number;
  commentDrafts?: Record<ShapeIRI, string>;
  previewShapeLoading?: boolean;
  exportIsInProgress?: boolean;
  files?: Record<string, ResourceData>;

  projects?: Record<string, ResourceData>;
  currentFileIRI?: string;
  overlay?: 'image-prompt';
  imagePrompt?: {
    isLoading?: boolean;
    prompt: string;
    imageIRI?: string;
    imageBlob?: Blob;
  };
  currentAnimationId?: string;
  animationsByResourceByFrame?: Record<
    ResourceIRI,
    Record<AnimationId, Partial<Record<AnimationKeys, AnimationItem>>>
  >;
  animationsByFrameByResource?: Record<
    AnimationId,
    Partial<Record<ResourceIRI, Partial<Record<AnimationKeys, AnimationItem>>>>
  >;
  containerMenu?: Record<string, ContainerMenuItem>;
  hoveredShape?: string;
  prompts?: Array<{
    text?: string;
    files?: Array<{
      type: 'image' | 'video' | 'doc';
      url: string;
      name?: string;
      docType?: 'pdf' | 'ppt';
      durationSec?: number;
    }>;
  }>;
  colors?: Array<string>;

  projectPreviewIsLoading?: boolean;
  newProjectName?: string;
}
export const initialEditorState: EditorState = {
  fontDescriptors: {},
  hiddenShapes: {},
  showComponentSearch: false,
  loading: false,
  descriptors: {},
  currentDescriptors: {},
  originalDescriptors: {},
  selectedShapes: {},
  isPatchLoading: false,
  bBoxes: {},
  baseShapeTransforms: {},
  originalShapeTransforms: {},
  currentShapeTransforms: {},
  baseSvgAttributes: {},
  originalSVGAttributes: {},
  currentSVGAttributes: {},
  noAnimationMode: false,
  fontLoaded: true,
  loadedScenes: null,
  updatesByState: {},
  shapes: {},
  visitStack: [],
  scenesAreLoaded: false,
  bulkUpdates: {},
  bulkUpdatesNew: {},
  canvasPosition: {
    x: 0,
    y: 0,
    scale: {
      x: 1,
      y: 1,
    },
  },
  crudEvents: {
    patches: {},
    posts: {},
    deletes: {
      // 'http://nowords.com#53abb8a0-9bc9-11f0-9943-f90cd4643dbc': 'nw:Shape',
      // 'http://nowords.com#58041b80-9af3-11f0-bd59-bddc4cc2ae8c': 'nw:Shape',
      // 'http://nowords.com#21520000-9bea-11f0-9ebf-db4f8d69963e': 'nw:Shape',
      // 'http://nowords.com#ddd887f0-9b11-11f0-b7e1-a79bc2158b6d': 'nw:Shape',
      // 'http://nowords.com#f2441050-9af4-11f0-a0d5-bf6865ebcca2': 'nw:Shape',
    },
  },
  editorState: {
    panelOpened: null,
  },
  changeTookPlace: new Date().getTime(),
  commentDrafts: {},
  previewShapeLoading: false,
  exportIsInProgress: false,
  imagePrompt: {
    prompt: '',
    imageIRI: '',
    imageBlob: null,
  },
  animationsByResourceByFrame: {},
  animationsByFrameByResource: {},
  currentFileIRI: null,
  files: {},
  projects: {},
  containerMenu: {},
  prompts: [],
  newProjectName: '',
};
export const editorReducer = createImmerReducer(
  initialEditorState,
  on(setProjectPreviewIsLoading, (state, { value }) => {
    state.projectPreviewIsLoading = value;
    return state;
  }),
  on(
    setAnimationConfigBase,
    (state, { IRIs, baseType, animationType, float, scale, by, mode }) => {
      for (const IRI of IRIs) {
        // if (!animationType && !float && !scale) {
        //   set(state.descriptors[IRI], ['baseAnimations', baseType], undefined);
        // }

        if (animationType) {
          set(
            state.descriptors[IRI],
            ['baseAnimations', baseType, 'type'],
            animationType,
          );
        }

        if (scale !== undefined) {
          console.log('set.scale', scale);
          set(
            state.descriptors[IRI],
            ['baseAnimations', baseType, 'scale'],
            scale,
          );
        }

        if (float !== undefined) {
          set(
            state.descriptors[IRI],
            ['baseAnimations', baseType, 'float'],
            float,
          );
        }

        if (by !== undefined) {
          set(state.descriptors[IRI], ['baseAnimations', baseType, 'by'], by);
        }

        if (mode !== undefined) {
          set(
            state.descriptors[IRI],
            ['baseAnimations', baseType, 'mode'],
            mode,
          );
        }
      }
      return state;
    },
  ),
  on(setCurrentAnimationId, (state, { id }) => {
    // console.log('setCurrentAnimationId---------', id); //
    state.currentAnimationId = id;
    return state;
  }),
  on(setNewProjectName, (state, { name }) => {
    state.newProjectName = name;
    return state;
  }),
  on(setFontDescriptor, (state, { key, descriptor }) => {
    state.fontDescriptors[key] = descriptor;
    return state;
  }),
  on(setPreviewShapeLoading, (state, { value }) => {
    state.previewShapeLoading = value;
    return state;
  }),
  on(setExportIsInProgress, (state, { value }) => {
    state.exportIsInProgress = value;
    return state;
  }),
  on(setFileLoading, (state, { value }) => {
    state.isFileLoading = value;
    if (value) {
      state.previewShapeLoading = true;
    }
    return state;
  }),
  on(setCanvasPosition, (state, { x, y, scale }) => {
    state.canvasPosition = { x, y, scale };
    return state;
  }),
  on(generateImage, state => {
    state.imagePrompt.isLoading = true;
    return state;
  }),
  on(generateImageSuccess, (state, { imageBlob }) => {
    state.imagePrompt.imageBlob = imageBlob;
    state.imagePrompt.imageIRI = URL.createObjectURL(imageBlob);
    state.imagePrompt.isLoading = false;
    return state;
  }),
  // on(generateImageFailure, state => {
  //   state.imagePrompt.isLoading = false;
  //   return state;
  // }),
  on(setProjectInput, (state, { project, files }) => {
    for (const file of files) {
      state.files[file.IRI] = file;
    }
    state.projects[project.IRI] = project;
    return state;
  }),
  on(clearImagePrompt, state => {
    state.imagePrompt = {
      prompt: '',
      imageIRI: '',
      isLoading: false,
      imageBlob: null,
    };
    return state;
  }),
  on(setColors, (state, { colors }) => {
    state.colors = [...colors];
    return state;
  }),
  on(addColor, (state, { color }) => {
    state.colors ||= [];
    state.colors.push(color);
    return state;
  }),
  on(removeColor, (state, { color }) => {
    state.colors = (state.colors || []).filter(c => c !== color);
    return state;
  }),
  on(updateColor, (state, { index, color }) => {
    if (state.colors && index >= 0 && index < state.colors.length) {
      state.colors[index] = color;
    }
    return state;
  }),
  on(reorderColors, (state, { previousIndex, currentIndex }) => {
    if (!state.colors || previousIndex === currentIndex) {
      return state;
    }
    const arr = state.colors;
    const [moved] = arr.splice(previousIndex, 1);
    arr.splice(currentIndex, 0, moved);
    return state;
  }),
  on(clearColors, state => {
    state.colors = [];
    return state;
  }),

  on(setImagePromptText, (state, { text }) => {
    state.imagePrompt.prompt = text;
    return state;
  }),
  on(addPrompt, (state, { prompt }) => {
    state.prompts ||= [];
    state.prompts.push(prompt);
    return state;
  }),
  on(addToFileVisitStack, (state, { ID }) => {
    state.visitStack.push(ID);
    return state;
  }),
  on(setCommentDraft, (state, { commentIRI, text }) => {
    state.commentDrafts[commentIRI] = text;
    return state;
  }),
  on(clearCommentDraft, (state, { commentIRI }) => {
    delete state.commentDrafts[commentIRI];
    return state;
  }),
  on(setSelectedStoryBoardItem, (state, { id }) => {
    state.selectedStoryBoardItem = id;
    return state;
  }),
  on(setStoryBoardItem, state => {
    return state;
  }),
  on(setOverlay, (state, { value }) => {
    state.overlay = value;
    return state;
  }),
  on(popVisitStack, state => {
    state.visitStack.pop();
    return state;
  }),
  on(setShape, (state, { shape }) => {
    const { IRI } = shape;
    state.shapes[IRI] = shape;
    return state;
  }),
  on(setFile, (state, { file }) => {
    const { IRI } = file;
    state.files[IRI] = file;
    return state;
  }),
  on(setShapeDescriptors, (state, { shapes }) => {
    shapes.map(shape => {
      _set(
        state.shapes,
        [shape.IRI, 'literals', 'descriptor'],
        shape.literals.descriptor,
      );
    });
    return state;
  }),
  // on(deleteComponent, (state, { IRI }) => {
  //   delete state.files[IRI].relationships.parent;
  //   return state;
  // }),
  on(toggleEditorState, (state, { key, value, force }) => {
    if (state.editorState[key] == value && !force) {
      state.editorState[key] = null;
    } else {
      state.editorState[key] = value;
    }
    return state;
  }),
  on(_setRelationshipBase, (state, { subject, relationship, object, save }) => {
    switch (relationship) {
      case 'file':
        const [shapeIRI, fileIRI] = [subject, object];
        set(state.shapes[shapeIRI], ['relationships', 'file'], fileIRI);
        // other direction //
        set(state.files[fileIRI].relationships, ['shapes', shapeIRI], true);
        break;
      case 'childOf':
        const [shape, parentShape] = [subject, object];

        set(state.shapes[shape], ['relationships', 'childOf'], parentShape);

        // other direction
        if (state.shapes[parentShape]) {
          set(
            state.shapes[parentShape].relationships,
            ['children', shape],
            true,
          );
        }
        if (state.files[parentShape]) {
          set(
            state.files[parentShape].relationships,
            ['children', shape],
            true,
          );
        }
        // -- //
        break;
    }

    if (save && !state.crudEvents.posts[subject]) {
      set(
        state.crudEvents.patches,
        [subject, 'relationships', relationship],
        true,
      );
    }
    // -- // -- // -- //
    return state;
  }),
  on(
    setRelationshipBase,
    (state, { subject, subjectType, relationship, object, oneToMany }) => {
      if (oneToMany) {
        _set(
          subjectType == 'nw:Shape' ? state.shapes : state.files,
          [subject, 'relationships', relationship, object],
          true,
        );
      } else {
        _set(
          subjectType == 'nw:Shape' ? state.shapes : state.files,
          [subject, 'relationships', relationship],
          object,
        );
      }
      return state;
    },
  ),
  // on(
  //   removeRelationshipBase,
  //   (state, { subject, subjectType, relationship, object }) => {
  //     if (object) {
  //       delete (subjectType == 'nw:Shape' ? state.shapes : state.files)[subject]
  //         ?.relationships[relationship]?.[object];
  //     } else {
  //       delete (subjectType == 'nw:Shape' ? state.shapes : state.files)[subject]
  //         ?.relationships[relationship];
  //     }
  //     return state;
  //   },
  // ),
  on(deleteShapeAction, (state, { IRI }) => {
    const shape = state.shapes[IRI];
    if (!shape) {
      return state;
    }
    const parent =
      (shape.relationships.childOf as string) ||
      (shape.relationships.file as string);
    if (!parent) {
      return state;
    }
    // -- // -- // -- //

    if (state.shapes[parent]) {
      delete state.shapes[parent].relationships.shapes?.[IRI];
    } else if (state.files[parent]) {
      delete state.files[parent].relationships.shapes?.[IRI];
    }
    return state;
  }),
  on(setCanvasShapes, (state, { shapes, merge, files }) => {
    if (!merge) {
      state.scenes = [];
      state.currentScene = null;
      state.descriptors = {};
      state.files = {};
      state.shapes = {};
      state.currentDescriptors = {};
      state.originalDescriptors = {};
      state.selectedShapes = {};
      state.updatesByState = {};
      state.isPatchLoading = false;
      state.bBoxes = {};
      state.baseShapeTransforms = {};
      state.originalShapeTransforms = {};
      state.currentShapeTransforms = {};
      state.baseSvgAttributes = {};
      state.originalSVGAttributes = {};
      state.currentSVGAttributes = {};
      state.hiddenShapes = {};
      state.animationsByFrameByResource = {};
      state.animationsByResourceByFrame = {};
    }

    state.selectedStoryBoardItem = undefined;

    // -- // -- // -- // -- // -- // -- // -- //
    // console.log('setCanvasShapes > files', files);
    // -- //
    for (const file of files || []) {
      state.files[file.IRI] = cloneDeep(file);
    }

    for (const shape of [...files, ...shapes]) {
      const IRI = shape.IRI;

      // console.log('shape.relationships.file', shape.relationships.parent);
      state.shapes[IRI] = cloneDeep(shape);
      // -- // -- //
      const descriptor = shape.literals.descriptor;

      state.descriptors[IRI] = omit(descriptor, ['position', 'svgAttributes']);
      state.currentDescriptors[IRI] = omit(descriptor, [
        'position',
        'svgAttributes',
      ]);
      state.originalDescriptors[IRI] = omit(descriptor, [
        'position',
        'svgAttributes',
      ]);
      state.updatesByState[IRI] = descriptor.updatesByState;

      const { animations, position: transform, svgAttributes } = descriptor;

      Object.entries(animations || {}).map(([animationId, animation]) => {
        set(state.animationsByFrameByResource, [animationId, IRI], animation);
        set(state.animationsByResourceByFrame, [IRI, animationId], animation);
      });

      state.baseShapeTransforms[IRI] = transform;
      state.originalShapeTransforms[IRI] = transform;
      state.currentShapeTransforms[IRI] = transform;

      state.baseSvgAttributes[IRI] = svgAttributes;
      state.originalSVGAttributes[IRI] = svgAttributes;
      state.currentSVGAttributes[IRI] = svgAttributes;
    }

    for (const shape of shapes) {
      const { parent } = shape.relationships;

      if (state.files[parent as string]) {
        // console.log('------ setOneToMany --------');
        _set(
          state.files[parent as string],
          ['relationships', 'shapes', shape.IRI],
          true,
        );
      }

      if (state.shapes[parent as string]) {
        _set(
          state.shapes[parent as string],
          ['relationships', 'shapes', shape.IRI],
          true,
        );
      }
    }
    // console.log('setCanvasShapes', state);
    return state;
  }),
  on(setBulkUpdateItem, (state, { item, items }) => {
    // console.log('set-bulk-update-item', items); //
    // console.log('set-bulk-update-item', { item, items }); //
    (item ? [item] : items).map(({ IRI, key, innerKey, value, base }) => {
      // _set(
      //   state.bulkUpdates,
      //   [IRI, key, innerKey].filter(v => !!v),
      //   value,
      // );

      // state.bulkUpdates[IRI] ||= {};

      // if (innerKey) {
      //   set(state.bulkUpdates[IRI], [key, innerKey], { value, base });
      // } else {
      //   set(state.bulkUpdates[IRI], [key], { value, base });
      // }

      /* console.log('set-bulk-update-item', {
        IRI,
        key,
        innerKey,
        value,
        base,
      }); */
      _set(state.bulkUpdatesNew, [IRI, key, innerKey], {
        value,
        base,
      });
    });

    return state;
  }),
  on(clearBulkUpdates, state => {
    state.bulkUpdates = {};
    return state;
  }),
  on(addAnimationsOfShapesToStoreBase, (state, { animations }) => {
    Object.entries(animations).map(([IRI, animationsById]) => {
      Object.entries(animationsById).map(([animationId, animationsByKey]) => {
        // console.log('animation-array', animationArray);
        Object.entries(animationsByKey).map(([animationKey, animationItem]) => {
          _set(
            state.animationsByFrameByResource,
            [animationId, IRI, animationKey],
            animationItem,
          );
          _set(
            state.animationsByResourceByFrame,
            [IRI, animationId, animationKey],
            animationItem,
          );
        });
      });
    });
    return state;
  }),
  on(bulkUpdateFinish, state => {
    const { currentAnimationId, bulkUpdatesNew } = state;
    Object.entries(bulkUpdatesNew || {}).map(([shapeIRI, updates]) => {
      Object.entries(updates).map(([animationKey, updateValue]) => {
        Object.entries(updateValue).map(([innerKey, updateValue]) => {
          if (innerKey == 'undefined') {
            innerKey = undefined;
          }
          const { value, base } = updateValue;
          if (!base) {
            console.log(
              '!base - updateValue',
              current(updateValue),
              'innerKey',
              innerKey,
            );
            try {
              state.animationsByResourceByFrame[shapeIRI] ||= {};
              state.animationsByResourceByFrame[shapeIRI][
                currentAnimationId
              ] ||= {};

              _set(
                state.animationsByResourceByFrame[shapeIRI][currentAnimationId],
                [animationKey, 'value', innerKey].filter(val => !!val),
                value,
              );

              console.log('set.animationsByResourceByFrame', {
                base: current(
                  state.animationsByResourceByFrame[shapeIRI][
                    currentAnimationId
                  ],
                ),
                keys: [animationKey, 'value', innerKey].filter(val => !!val),
                value,
              });
              state.animationsByFrameByResource[currentAnimationId] ||= {};
              state.animationsByFrameByResource[currentAnimationId][
                shapeIRI
              ] ||= {};
              _set(
                state.animationsByFrameByResource[currentAnimationId][shapeIRI],
                [animationKey, 'value', innerKey].filter(val => !!val),
                value,
              );
            } catch (error) {
              console.log('--------- game.set-error---------', error);
            }
          }

          switch (animationKey) {
            case 'translate':
            case 'scale':
            case 'rotation':
              /* console.log('editor.reducer > transform > bulkUpdateFinish', {
                shapeIRI,
                animationKey,
                innerKey,
                value: current(value),
                base,
              }); */
              _set(
                state.currentShapeTransforms,
                [shapeIRI, animationKey, innerKey].filter(val => !!val),
                value,
              );

              if (base) {
                _set(
                  state.baseShapeTransforms,
                  [shapeIRI, animationKey, innerKey].filter(val => !!val),
                  value,
                );
              }
              break;
            case 'fill':
            case 'stroke':
              _set(
                state.currentSVGAttributes,
                [shapeIRI, animationKey, innerKey].filter(val => !!val),
                value,
              );
              if (base) {
                _set(
                  state.baseSvgAttributes,
                  [shapeIRI, animationKey, innerKey].filter(val => !!val),
                  value,
                );
              }
              break;
            case 'show-hide':
              console.log('editor.reducer > show-hide', value);
              _set(state.hiddenShapes, [shapeIRI], value);
              // _set(
              //   state.currentDescriptors,
              //   [shapeIRI, animationKey, innerKey].filter(val => !!val),
              //   value,
              // );
              // if (base) {
              //   _set(
              //     state.descriptors,
              //     [shapeIRI, animationKey, innerKey].filter(val => !!val),
              //     value,
              //   );
              // }
              break;
            default:
              _set(
                state.currentDescriptors,
                [shapeIRI, animationKey, innerKey].filter(val => !!val),
                value,
              );
              /* console.log('editor.reducer > default', {
                animationKey,
                innerKey,
                value,
                base,
                // value: current(value),
              }); */ 1;
              if (base) {
                _set(
                  state.descriptors,
                  [shapeIRI, animationKey, innerKey].filter(val => !!val),
                  value,
                );
              }
              break;
          }
        });
      });
    });
    // } catch (error) {
    //   console.error('error > bulkUpdateFinish', error);
    // }
    state.bulkUpdatesNew = {};
    // console.log('editor.reducer > bulkUpdateFinish > end ---------');
    return state;
  }),
  on(resetBaseState, state => {
    state.currentDescriptors = state.descriptors;
    state.currentShapeTransforms = state.baseShapeTransforms;
    state.currentSVGAttributes = state.baseSvgAttributes;
    return state;
  }),
  // on(addFile, (state, { file }) => {
  //   // state.files[file.IRI] = file;
  //   const parentFileIRI = file.relationships.componentOf as string;
  //   if (parentFileIRI) {
  //     set(
  //       state.files,
  //       [parentFileIRI, 'relationships', 'components', file.IRI],
  //       true,
  //     );
  //   }
  //   return state;
  // }),
  on(setHiddenShape, (state, { IRI, value }) => {
    state.hiddenShapes[IRI] = value;
    return state;
  }),
  on(loadProjectWithFilesById, state => {
    state.shapes = null;
    state.files = null;
    return state;
  }),
  on(setShapes, (state, { shapes }) => {
    // state.shapes = {
    //   ...state.shapes,
    //   ...shapes,
    // };
    state.shapes = shapes;
    return state;
  }),
  on(setFiles, (state, { files }) => {
    state.files = files;
    return state;
  }),
  on(setFontLoaded, (state, { value }) => {
    state.fontLoaded = value;
    return state;
  }),
  on(setNoAnimationMode, (state, { value }) => {
    state.noAnimationMode = value;
    return state;
  }),
  on(setFileChanged, (state, { value }) => {
    state.fileChanged = value;
    return state;
  }),
  on(saveScenePosition, (state, { scene, position }) => {
    const sceneIndex = state.scenes.findIndex(s => s.name == scene);
    state.scenes[sceneIndex].position = position;
    state.fileChanged = true;
    return state;
  }),
  on(saveSubScenePosition, (state, { scene, subScene, position }) => {
    const sceneIndex = state.scenes.findIndex(s => s.name == scene);
    const subSceneIndex = state.scenes[sceneIndex].subscenes.findIndex(
      s => s.name == subScene,
    );
    state.scenes[sceneIndex].subscenes[subSceneIndex].position = position;
    state.fileChanged = true;
    return state;
  }),
  on(setCurrentScene, (state, { scene }) => {
    state.currentScene = [scene];
    return state;
  }),
  on(setCurrentScenes, (state, { scenes }) => {
    // console.log('set-current-scenes', scenes); //
    state.currentScene = scenes;
    return state;
  }),
  on(selectSubSceneBase, (state, { name }) => {
    state.currentScene[1] = name;
    return state;
  }),
  on(setSubSceneName, (state, { parentIndex, index, name }) => {
    state.currentScene[1] = name;
    state.scenes[parentIndex].subscenes[index].name = name;
    state.fileChanged = true;
    return state;
  }),
  on(setScenes, (state, { scenes }) => {
    state.scenes = scenes;
    state.fileChanged = true;
    return state;
  }),
  on(addSubScene, (state, { parentIndex, name, index }) => {
    state.scenes[parentIndex].subscenes ||= [];
    state.scenes[parentIndex].subscenes.splice(index, 0, { name });
    state.fileChanged = true;
    return state;
  }),
  on(setCurrentDescriptor, (state, { IRI, descriptor }) => {
    state.currentDescriptors[IRI] = descriptor;
    return state;
  }),
  on(setOriginalDescriptor, (state, { IRI, descriptor }) => {
    state.originalDescriptors[IRI] = descriptor;
    state.currentDescriptors[IRI] = descriptor;
    state.descriptors[IRI] = descriptor;
    return state;
  }),
  on(
    setAttributeByState,
    (state, { IRIs, state: fileState, key, innerKey, value, keys }) => {
      IRIs.map(IRI => {
        _set(
          state.updatesByState,
          keys
            ? [IRI, fileState, ...keys]
            : [IRI, fileState, key, innerKey].filter(v => !!v),
          value,
        );
      });
      return state;
    },
  ),
  on(setLoadedScenes, (state, { value }) => {
    state.loadedScenes = value;
    return state;
  }),
  on(addLoadedScene, (state, { key }) => {
    state.loadedScenes ||= {};
    state.loadedScenes[key] = true;
    return state;
  }),
  on(setOriginalSVGAttributes, (state, { IRI: shapeIRI, svgAttributes }) => {
    state.originalSVGAttributes[shapeIRI] = svgAttributes;
    state.currentSVGAttributes[shapeIRI] = svgAttributes;
    state.baseSvgAttributes[shapeIRI] = svgAttributes;
    return state;
  }),
  on(setCurrentSVGAttributesOfShape, (state, { shapeIRI, svgAttributes }) => {
    state.currentSVGAttributes[shapeIRI] = {
      ...state.currentSVGAttributes[shapeIRI],
      ...svgAttributes,
    };
    return state;
  }),
  on(setSVGAttributesOfShape, (state, { shapeIRI, svgAttributes }) => {
    state.baseSvgAttributes[shapeIRI] = {
      ...state.baseSvgAttributes[shapeIRI],
      ...svgAttributes,
    };
    return state;
  }),
  on(setDescriptorSubAttribute, (state, { shapeIRI, key, innerKey, value }) => {
    console.log('set-transform-attribute');
    _set(
      state.currentDescriptors,
      [shapeIRI, key, innerKey].filter(v => !!v),
      value,
    );
    _set(state.descriptors, [shapeIRI, key, innerKey], value);
    return state;
  }),
  on(
    setCurrentDescriptorSubAttribute,
    (state, { shapeIRI, key, innerKey, value }) => {
      _set(
        state.currentDescriptors,
        [shapeIRI, key, innerKey].filter(v => !!v),
        value,
      );
      return state;
    },
  ),
  on(setSelectedShapes, (state, { shapes }) => {
    state.selectedShapes = shapes;
    state.editorState.panelOpened = null;
    return state;
  }),
  on(selectShape, (state, { IRI, shift }) => {
    if (shift) {
      state.selectedShapes[IRI] = true;
    } else {
      state.selectedShapes = {
        [IRI]: true,
      };
    }
    return state;
  }),
  on(addState, (state, { name }) => {
    state.states ||= [];
    state.states.push(name);
    state.fileChanged = true;
    return state;
  }),
  on(selectState, (state, { name }) => {
    state.selectedState = name;
    return state;
  }),
  on(deselectShape, (state, { IRI }) => {
    delete state.selectedShapes[IRI];
    return state;
  }),
  on(selectAllShapes, state => ({
    ...state,
    selectedShapes: Object.keys(state.shapes).reduce((prev, curr) => {
      prev[curr] = true;
      return prev;
    }, {}),
  })),
  on(deselectAllShapes, state => {
    state.selectedShapes = {};
    return state;
  }),
  on(setResourcePost, (state, { IRI, IRIs, resourceType }) => {
    const _IRIs = IRIs ? IRIs : [IRI];
    _IRIs.map(IRI => {
      set(state.crudEvents.posts, [IRI], resourceType);
    });
    return state;
  }),
  on(setResourcePatch, (state, { IRI, IRIs, field, key }) => {
    const _IRIs = IRIs ? IRIs : [IRI];
    _IRIs.map(IRI => {
      if (state.crudEvents.posts[IRI]) {
        return;
      }
      set(state.crudEvents.patches, [IRI, field, key], true);
    });
    return state;
  }),
  on(setResourceDelete, (state, { IRI, IRIs }) => {
    const _IRIs = IRIs ? IRIs : [IRI];
    // console.log('editor.reducer > setResourceDelete', IRI);
    _IRIs.map(IRI => {
      if (state.crudEvents.posts[IRI]) {
        delete state.crudEvents.posts[IRI];
        return;
      }
      if (state.crudEvents.patches[IRI]) {
        delete state.crudEvents.patches[IRI];
      }
      set(state.crudEvents.deletes, [IRI], 'nw:Shape');
    });
    return state;
  }),
  on(resetPatchedShapes, state => ({
    ...state,
    crudEvents: {
      patches: {},
      posts: {},
      deletes: {},
    },
  })),
  on(setSubsceneLoaded, state => {
    state.scenesAreLoaded = true;
    return state;
  }),
  on(updateDescriptorOfShapeBaseAction, (state, { IRI, descriptor }) => {
    // TDOOx - implement original
    state.descriptors[IRI] = {
      ...state.descriptors[IRI],
      ...descriptor,
    };
    state.currentDescriptors[IRI] = {
      ...state.currentDescriptors[IRI],
      ...descriptor,
    };
    return state;
  }),
  on(updateCurrentDescriptorBaseAction, (state, { IRI, descriptor }) => {
    // TDOOx - implement originally
    state.currentDescriptors[IRI] = {
      ...state.descriptors[IRI],
      ...descriptor,
    };
    return state;
  }),
  on(deleteShapeFromFileAction, (state, { IRI }) => {
    delete state.selectedShapes[IRI];
    delete state.descriptors[IRI];
    delete state.currentDescriptors[IRI];
    delete state.baseSvgAttributes[IRI];
    delete state.currentSVGAttributes[IRI];
    return state;
  }),
  on(setSaveLoading, (state, { value }) => {
    state.isPatchLoading = value;
    return state;
  }),
  on(loadFileAction, state => {
    state.isSaveLoading = true;
    return state;
  }),
  // TODO - implement
  on(addNewState, state => {
    return state;
  }),
  // TODO - implement
  on(removeState, state => {
    return state;
  }),
  // TODO - implement
  on(setCurrentState, state => {
    return state;
  }),
  on(setNewShapeAction, (state, { data }) => {
    state.crudEvents.posts[data.IRI] = 'nw:Shape';
    return state;
  }),
  on(setShapeLabel, (state, { IRI, label }) => {
    state.shapes[IRI].literals.label = label;
    return state;
  }),
  on(toggleSelectAction, (state, { IRI }) => {
    state.selectedShapes[IRI] = !state.selectedShapes[IRI];
    return state;
  }),
  on(setBBoxOfShape, (state, { IRI, bBox }) => {
    state.bBoxes[IRI] = bBox;
    return state;
  }),
  on(setShapeTranslateBase, (state, { IRI, translate }) => {
    _set(state.baseShapeTransforms, [IRI, 'translate'], translate);
    _set(state.currentShapeTransforms, [IRI, 'translate'], translate);
    return state;
  }),
  on(setCurrentShapeTranslate, (state, { IRI, translate }) => {
    _set(state.currentShapeTransforms, [IRI, 'translate'], translate);
    return state;
  }),
  on(setBaseShapeTransform, (state, { IRI, transform }) => {
    console.log('set-shape-transform', IRI, transform);
    _set(state.baseShapeTransforms, IRI, transform);
    _set(state.currentShapeTransforms, IRI, transform);
    return state;
  }),
  on(setcompleteShapeDescriptor, (state, { IRI, descriptor }) => {
    _set(state.shapes, [IRI, 'literals', 'descriptor'], descriptor);
    return state;
  }),
  // this is called only once at the shape initialisation
  on(setShapeOriginalTransform, (state, { IRI, transform }) => {
    _set(state.originalShapeTransforms, [IRI], transform);
    _set(state.currentShapeTransforms, [IRI], transform);
    _set(state.baseShapeTransforms, [IRI], transform);
    return state;
  }),
  on(setShowComponentSearch, (state, { value }) => {
    state.showComponentSearch = value;
    return state;
  }),
  on(setChangeTookPlace, state => {
    state.changeTookPlace = new Date().getTime();
    return state;
  }),
  on(removeAnimationItemBaseAction, (state, { key, IRI }) => {
    const { currentAnimationId } = state;
    delete state.animationsByFrameByResource[currentAnimationId]?.[IRI]?.[key];
    delete state.animationsByResourceByFrame[IRI]?.[currentAnimationId]?.[key];
    return state;
  }),
  on(setCurrentFileIRI, (state, { IRI }) => {
    console.log('set-current-file-iri', IRI);
    state.currentFileIRI = IRI;
    return state;
  }),
  on(setCurrentFileID, (state, { id }) => {
    state.currentFileIRI = IdToIRI(id);
    return state;
  }),
  on(setContainerMenuItem, (state, { IRI, menu }) => {
    // console.log('set-container-menu-item', IRI, menu);
    state.containerMenu ||= {};
    state.containerMenu[IRI] = menu;
    return state;
  }),
  on(setContainerMenuItemState, (state, { IRI, state: containerState }) => {
    // console.log('set-container-menu-item-state', IRI, state);
    state.containerMenu[IRI].state = containerState;
    return state;
  }),
  on(setContainerItemAction, (state, { IRI, action }) => {
    // console.log('set-container-menu-item-action', IRI, action);
    const currentState = state.containerMenu[IRI].state;
    if (currentState === 'active') {
      return state;
    }

    switch (action) {
      case 'mouseenter':
        state.containerMenu[IRI].state = 'hover';
        break;
      case 'mouseleave':
        state.containerMenu[IRI].state = 'hidden';
        break;
      case 'click':
        state.containerMenu[IRI].state = 'active';
        break;
    }
    return state;
  }),
  on(removeContainerMenuItem, (state, { IRI }) => {
    console.log('remove-container-menu-item', IRI);
    delete state.containerMenu[IRI];
    return state;
  }),
  on(setHoveredShape, (state, { IRI }) => {
    state.hoveredShape = IRI;
    return state;
  }),
  on(clearContainerMenu, state => {
    console.log('clear-container-menu');
    state.containerMenu = {};
    return state;
  }),
  // on(setResource, (state, { resource }) => {
  //   console.log('setResource', resource);
  //   state.resources[resource.IRI] = resource;
  //   return state;
  // }),
  // on(setResources, (state, { resources }) => {
  //   // console.log('setResources', resources);
  //   state.resources = {
  //     ...state.resources,
  //     ...resources,
  //   };
  //   return state;
  // }),
  // on(setResourceLabelBase, (state, { IRI, label }) => {
  //   set(state.resources, [IRI, 'literals', 'label'], label);
  //   return state;
  // }),
);
